export default "__VITE_ASSET__LDJfXdyp__"